import { createSelector } from 'reselect';

const contactsIded = state => state.contacts.itemsById;
const allContacts = state => state.contacts.items;

export const contactsById = createSelector(contactsIded, cts => cts);
export const contacts = createSelector(allContacts, cts => cts);



// WEBPACK FOOTER //
// ./src/redux/selectors/contacts.js